import { Suspense } from 'react';
import { Routes, Route } from 'react-router-dom';
import { LangWrapper, LocalizedRedirector } from './i18n/i18nRouting';
import { SUPPORTED_LANGS } from './i18n/routingUtils';
import { AppRoutes } from './router';
import { RouteSeo } from './components/common/RouteSeo';
import { LoadingSpinner } from './components/ui/LoadingSpinner';
import { ScrollToTop } from '@/components/common/ScrollToTop';
import { usePartnerTracking } from '@/hooks/partners';

export function App() {
  usePartnerTracking();

  return (
    <>
      <ScrollToTop />
      <LocalizedRedirector />
      <RouteSeo />
      <Suspense fallback={<LoadingSpinner fullScreen />}>
        <Routes>
          {SUPPORTED_LANGS.map((lang) => (
            <Route key={lang} path={`/${lang}/*`} element={<LangWrapper lang={lang} />}>
              <Route path="*" element={<AppRoutes />} />
            </Route>
          ))}
          <Route path="/*" element={<AppRoutes />} />
        </Routes>
      </Suspense>
    </>
  );
}
